function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0.625,0 L19.7411165,0 C19.9068768,2.18999637e-15 20.065848,0.065848025 20.1830583,0.183058262 L29.8169418,9.81694175 C29.934152,9.934152 30,10.0931232 30,10.2588835 L30,39.375 C30,39.7201779 29.7201779,40 29.375,40 L0.625,40 C0.279822031,40 4.22721094e-17,39.7201779 0,39.375 L0,0.625 C-4.22721094e-17,0.279822031 0.279822031,6.34081644e-17 0.625,0 Z",
  id: "path-1"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "disc"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-11"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-10"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-9"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4"
}, /*#__PURE__*/React.createElement("g", {
  id: "Mask",
  fill: "#EFF4F6",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.625,0 L19.7411165,0 C19.9068768,2.18999637e-15 20.065848,0.065848025 20.1830583,0.183058262 L29.8169418,9.81694175 C29.934152,9.934152 30,10.0931232 30,10.2588835 L30,39.375 C30,39.7201779 29.7201779,40 29.375,40 L0.625,40 C0.279822031,40 4.22721094e-17,39.7201779 0,39.375 L0,0.625 C-4.22721094e-17,0.279822031 0.279822031,6.34081644e-17 0.625,0 Z",
  id: "path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "fold-Clipped"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "path-1"
}), /*#__PURE__*/React.createElement("rect", {
  id: "fold",
  fill: "#D5E1E5",
  fillRule: "nonzero",
  mask: "url(#mask-2)",
  x: 20,
  y: 0,
  width: 10,
  height: 10
}))))))), /*#__PURE__*/React.createElement("g", {
  id: "disk",
  transform: "translate(6.250000, 13.750000)",
  fill: "#637282",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.75,0 C3.92510417,0 0,3.92510417 0,8.75 C0,13.5748958 3.92510417,17.5 8.75,17.5 C13.5748958,17.5 17.5,13.5748958 17.5,8.75 C17.5,3.92510417 13.5748958,0 8.75,0 Z M8.75,10.9375 C7.54177081,10.9375 6.5625,9.95822919 6.5625,8.75 C6.5625,7.54177081 7.54177081,6.5625 8.75,6.5625 C9.95822919,6.5625 10.9375,7.54177081 10.9375,8.75 C10.9375,9.95822919 9.95822919,10.9375 8.75,10.9375 Z",
  id: "Shape"
}))));

var SvgDisc = function SvgDisc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "40px",
    viewBox: "0 0 30 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDisc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/disc.4e327bcb.svg";
export { ForwardRef as ReactComponent };